import Vue from "vue"
import { protectedAxiosInstance } from "../../utils/axiosConfig"
export default {
	state: () => ({
		CHATS: {}
	}),
	mutations: {
		ADD_CHATS(state, friendList) {
			friendList.forEach(({ nickname }) => {
				Vue.set(state.CHATS, nickname, [])
			})
		},
		ADD_MESSAGE(state, { message, myProfile }) {
			let side = message.from === myProfile.nickname ? "to" : "from"

			Vue.set(
				state.CHATS[message[side]],
				state.CHATS[message[side]].length,
				message
			)
		}
	},
	actions: {
		async LOAD_MESSAGES({ commit, rootState }, friend) {
			const {
				data: { data: messages }
			} = await protectedAxiosInstance.get(
				`/chats-friends/history?friend=${friend}`
			)
			console.log("message loaded")
			messages.forEach((message) => {
				commit("ADD_MESSAGE", {
					message,
					myProfile: rootState.MY_PROFILE
				})
			})
		}
	},
	namespaced: true
}

//  I send -> {from: 'me', to: "them"}
//  They send -> {from: 'them', to: "me"}

// [{from: me, to: them}, {from: them, to: me} ]

// message.from === me ? to : from
